// New illustration — ports app/(privado)/conto/adicionar/page.tsx.

import { Link } from "react-router";
import { Flourish } from "@/components/ui/Flourish";
import { FormIlustracao } from "@/components/forms/FormIlustracao";
import { useTitle } from "@/components/ui/useTitle";
import { useMilestoneSummary } from "@/api/queries";

export function ContoAdicionar() {
  useTitle("Nova ilustração");
  const marcos = useMilestoneSummary();

  return (
    <main className="mx-auto max-w-xl px-6 py-16">
      <header className="text-center">
        <p className="font-display text-lg italic text-ouro-600">Mais uma página</p>
        <h1 className="mt-2 font-display text-4xl text-tinta">Nova ilustração</h1>
        <div className="my-6">
          <Flourish />
        </div>
      </header>

      <FormIlustracao marcos={marcos.data ?? []} />

      <div className="mt-10 text-center">
        <Link
          to="/conto"
          className="text-sm text-ouro-600 underline-offset-4 transition-colors hover:text-ouro hover:underline"
        >
          ← Voltar ao conto
        </Link>
      </div>
    </main>
  );
}
